import React, { useEffect, useState } from 'react';
import AddOrUpdateLearning from './AddOrUpdateLearning'; // Import the BlogAdd component
import { useFormik } from 'formik';
import { blogInitialValues, blogValidationSchema, learningInitialValues, learningValidationSchema } from '../../common/Validation';
import { addBlogApi, addOrUpdateLearningApi, deleteLearningApi, getBlogApi, getLearningsApi, updateBlogApi } from '../../../utils/ApiEndpointFunctions';
import toast from 'react-hot-toast';
import Spinwheel from '../../common/Spinwheel';
import { S3_URL } from '../../../utils/BaseUrl';
import ImageViewModal from '../../common/Modal/ImageViewModal';
import moment from 'moment';
import DeletedModal from '../../common/Modal/DeletedModal';
import ReactSelect from 'react-select';

const Learning = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [learning, setLearning] = useState([]);
  const [loading, setLoading] = useState(false)
  const [tableLoader, setTableLoader] = useState(true)
  const [selectedImg, setSelectedImg] = useState("")
  const imageViewModalId = "imageViewModalId"
  const addOrUpdateModalId = "addOrUpdateModalId"
  const deleteModalId = "categoryDeleteModal"
   const [selectedId, setSelectedId] = useState(null);
   const [addLoader, setAddLoader] = useState(false);
   const [selectedLanguage,setSelectedLanguage] = useState("en")

  const openModal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false);

  const addBlog = (newBlog) => {
    setLearning([...learning, { id: learning.length + 1, ...newBlog }]);
  };

  const getLearningLists = async () => {
    try {
      setTableLoader(true)
      const res = await getLearningsApi(selectedLanguage);
      if (res.status === 200) {
        console.log(res.data)
        setLearning(res.data?.data)
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong")
    }
    setTableLoader(false)
  }

  const handleSumbit = async (values) => {
    try {
      console.log(values)
      setLoading(true)
      const res = await addOrUpdateLearningApi(values);
      if (res.status === 200) {
        toast.success(res.data?.message)
        getLearningLists();
        closeModal();
        document.getElementById("addOrUpdateModalId").click();
      }
    } catch (error) {
      console.log(error)
      toast.error("Something went wrong")
    }
    setLoading(false)
  }

  const formik = useFormik({
    initialValues: learningInitialValues,
    onSubmit: handleSumbit,
    validationSchema: learningValidationSchema
  })

  useEffect(() => {
    getLearningLists()
  }, [selectedLanguage])

  const deleteLearning=async()=>{
    try {
      console.log(selectedId,"selectedId")
      setAddLoader(true)
      const res = await deleteLearningApi(selectedId);
      if (res.status === 200) {
        toast.success(res.data?.message)
        setAddLoader(false)
        getLearningLists()
        document.getElementById(deleteModalId).click();
      }
    } catch (error) {
      console.log(error)
      toast.error("Something went wrong")
      setAddLoader(false)
    }
  }

  const languageOptions =[
    {label:"English",value:"en"},
    {label:"French",value:"fr"}
  ]

  const handleLanguageChange=(value)=>{
      console.log("valueee",value?.value)
      setSelectedLanguage(value?.value)
  }

  return (
    <>
      <div className="main-content">
        <div className="container-fluid">
          <div className="row">
            <div className="main-content">
              <div className='card'>
                <div className="card-header">
                  <div className="d-flex justify-content-end flex-wrap align-items-center mt-3 mt-lg-0">
                    <div style={{ display: "-webkit-inline-box" }}>
                      <div className="d-flex gap-2 justify-content-end align-items-center">
                        <div className="d-flex align-items-center gap-2">
                          <ReactSelect className='reactSelectMinWidth' options={languageOptions}  value={languageOptions.find((opt) => opt.value === selectedLanguage)}  onChange={handleLanguageChange}  />
                        </div>
                        <button
                          className="btn btn-primary"
                          // data-bs-toggle="modal"
                          // data-bs-target="#addOrUpdateModalId"
                          onClick={() => { openModal(); formik.resetForm() }}
                        >
                          Add
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-md table-hover card-table">
                      <thead>
                        <tr>
                          <th scope="col">Title</th>
                          <th scope='col'>Type</th>
                          <th scope="col">Thumbnail</th>
                          <th scope="col">Description</th>
                          <th scope="col">Published</th>
                          <th scope="col"></th>
                        </tr>
                      </thead>
                      <tbody>
                        {tableLoader ? <tr>
                          <td colSpan={8} className='text-center'>
                            <Spinwheel />
                          </td>
                        </tr> :
                          learning.map((ele, index) => (
                            <tr key={ele.id}>
                              <td>{ele.title}</td>
                              <td>{ele.type}</td>
                              <td><div className="avatar avatar-xs align-middle me-2">
                                <img
                                  className="avatar-img rounded-circle"
                                  src={!ele.thumbnail ? "/images/profiledp.png" : `${S3_URL}/${ele?.thumbnail}`}
                                  alt="img"
                                  data-bs-toggle="modal"
                                  data-bs-target={`#${imageViewModalId}`}
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => { setSelectedImg(!ele.thumbnail ? "/images/profiledp.png" : `${S3_URL}/${ele?.thumbnail}`) }}
                                />
                              </div></td>
                              <td
                                dangerouslySetInnerHTML={{
                                  __html: ele.type === "video" ? ele.description : ele.content,
                                }}
                              />

                              <td>{ele.isPublish ? "Yes" : "No"}</td>

                              <td>
                                <div className="dropdown">
                                  <button
                                    className=" border-0 bg-white"
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-three-dots-vertical"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                                    </svg>
                                  </button>
                                  <ul
                                    className="dropdown-menu"
                                    style={{ zIndex: "1000" }}
                                  >
                                    <li className="dropdown-item">
                                      <div
                                        data-bs-toggle="modal"
                                        data-bs-target={`#${addOrUpdateModalId}`}
                                        onClick={() => { formik.setValues(ele); openModal() }}
                                        style={{ cursor: "pointer" }}
                                      >
                                        Edit
                                      </div>
                                    </li>
                                    <li className="dropdown-item" >
                                      <div
                                        data-bs-toggle="modal"
                                        data-bs-target={`#${deleteModalId}`}
                                        onClick={() => { setSelectedId(ele?.id) }}
                                        style={{ cursor: "pointer" }}
                                      >
                                        Delete
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ImageViewModal imgUrl={selectedImg} modalId={imageViewModalId} />
      <AddOrUpdateLearning isOpen={modalIsOpen} onClose={closeModal} onAdd={addBlog} modalId={addOrUpdateModalId} formik={formik} loading={loading} />
      <DeletedModal
        modalId={deleteModalId}
        message={""}
        deletedHandler={deleteLearning}
        loader={addLoader}
      />
    </>
  );
};

export default Learning;
